import React, { useState, useEffect } from "react"
import { Row, Col, Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input } from "reactstrap"
import Datatables from "components/Datatables/datatable"
import Select from "react-select"
import { get, post } from "helpers/api_helper"
import { PAYROLL_COMPONENTS_URL } from "helpers/url_helper"
import Notifications from "components/Notifications"

const SalaryComponent = () => {
    const [modal, setModal] = useState(false)
    const [isEdit, setIsEdit] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [dataRows, setDataRows] = useState({ rows: [], total_rows: 0 })
    const [pagination, setPagination] = useState({ limit: 10, page: 1, search: "" })
    
    const [formData, setFormData] = useState({
        name: "",
        type: "Earning",
        value_type: "Fixed",
        value: "",
        branch_id: "1"
    })

    const toggleModal = () => {
        if (modal) {
            setFormData({ name: "", type: "Earning", value_type: "Fixed", value: "", branch_id: "1" })
            setIsEdit(false)
        }
        setModal(!modal)
    }

    const brownBtnStyle = { backgroundColor: "#3d1e08", borderColor: "#3d1e08", color: "#fff" }

    const getData = async () => {
        setIsLoading(true)
        const res = await get(`${PAYROLL_COMPONENTS_URL}?page=${pagination.page}&limit=${pagination.limit}&search=${pagination.search}`)
        if (res.status === 200) {
            setDataRows(res.response)
        }
        setIsLoading(false)
    }

    useEffect(() => {
        getData()
    }, [pagination])

    const handleSubmit = async (e) => {
        e.preventDefault()
        const res = isEdit 
            ? await post(`${PAYROLL_COMPONENTS_URL}_update`, formData) 
            : await post(PAYROLL_COMPONENTS_URL, formData)
        
        if (res.status === 200 || res.status === true) {
            Notifications("success", res.message)
            toggleModal()
            getData()
        } else {
            Notifications("error", res.message)
        }
    }

    const handleEdit = (row) => {
        setFormData({ ...row })
        setIsEdit(true)
        setModal(true)
    }

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this component?")) {
            const res = await get(`${PAYROLL_COMPONENTS_URL}_delete?id=${id}`) // Using get for delete as implemented in backend with get('id')
            if (res.status === 200 || res.status === true) {
                Notifications("success", res.message)
                getData()
            } else {
                Notifications("error", res.message)
            }
        }
    }

    const columns = [
        { dataField: "id", text: "#" },
        { dataField: "name", text: "NAME" },
        { 
            dataField: "type", 
            text: "COMPONENT TYPE",
            formatter: (cell) => <span className={`badge rounded-pill ${cell === 'Earning' ? 'bg-info' : 'bg-secondary'}`}>{cell}</span>
        },
        { dataField: "value", text: "COMPONENT VALUE" },
        { dataField: "value_type", text: "VALUE TYPE" },
        {
            dataField: "status",
            text: "STATUS",
            formatter: (cell) => (
                <div className="form-check form-switch" dir="ltr">
                    <input type="checkbox" className="form-check-input" defaultChecked={cell == 1} />
                </div>
            )
        },
        {
            dataField: "action",
            text: "ACTION",
            formatter: (cell, row) => (
                <>
                    <Button color="light" size="sm" className="me-1" onClick={() => handleEdit(row)}><i className="far fa-edit text-primary"></i></Button>
                    <Button color="light" size="sm" onClick={() => handleDelete(row.id)}><i className="far fa-times-circle text-danger"></i></Button>
                </>
            )
        }
    ]

    return (
        <React.Fragment>
            <Datatables 
                title="Salary Components"
                titleClass="h5"
                columns={columns} 
                rows={dataRows.rows} 
                keyField="id" 
                rowsLength={dataRows.total_rows} 
                isSearch={false} 
                isAdd={true} 
                btnTitle="Add Salary Component"
                btnColor="success"
                handleAddButton={toggleModal}
                ssr={setPagination} 
                loading={isLoading} 
            />

            <Modal isOpen={modal} toggle={toggleModal} size="lg">
                <ModalHeader toggle={toggleModal}>{isEdit ? "Edit" : "Add"} Salary Component</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Name <span className="text-danger">*</span></Label>
                                    <Input 
                                        type="text" 
                                        placeholder="Enter name" 
                                        value={formData.name}
                                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Component Type <span className="text-danger">*</span></Label>
                                    <Select 
                                        options={[{ label: "Earning", value: "Earning" }, { label: "Deduction", value: "Deduction" }]} 
                                        value={{ label: formData.type, value: formData.type }}
                                        onChange={(opt) => setFormData({ ...formData, type: opt.value })}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Value Type <span className="text-danger">*</span></Label>
                                    <Select 
                                        options={[
                                            { label: "Fixed", value: "Fixed" }, 
                                            { label: "Percentage", value: "Percentage" },
                                            { label: "Basic Percent", value: "Basic Percent" }
                                        ]} 
                                        value={{ label: formData.value_type, value: formData.value_type }}
                                        onChange={(opt) => setFormData({ ...formData, value_type: opt.value })}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label>Value <span className="text-danger">*</span></Label>
                                    <Input 
                                        type="text" 
                                        placeholder="Enter value" 
                                        value={formData.value}
                                        onChange={(e) => setFormData({ ...formData, value: e.target.value })}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="mt-3">
                            <Button style={brownBtnStyle} type="submit">{isEdit ? "Update" : "Create"}</Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

export default SalaryComponent
